import { api } from "services/api"
import ErrorHandler from "./ErrorHandler"

interface InvoicePayload extends App.InvoiceParams {
  skip: number
  take: number
}

class ApiInvoices extends ErrorHandler {
  public async searchInvoices(params: InvoicePayload) {
    return api.get("/invoices/list", {
      params
    })
  }

  async updateInvoice(data: App.InvoiceUpdateStatusPayload) {
    return api.patch("/invoices/update", data)
  }
}

export default ApiInvoices
